import React, {useEffect, useState} from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';



// // style={{width:"100%" ,height:"100%"}}

function Introtwo() {

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
    
      useEffect(() => {
        const handleResize = () => {
          setIsSmallScreen(window.innerWidth <= 768);
        };
    
        window.addEventListener('resize', handleResize);
    
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);

 


  return (
    <Container 
    fluid 
   className="container-section"
   
    style={{backgroundColor:"#212020",
      display: "flex",
      alignItems: "center", 
      justifyContent: "center", 
      height: isSmallScreen ? "auto" : "100vh",
      paddingTop: isSmallScreen ? "5rem" : "auto",
      paddingBottom: isSmallScreen ? "5rem" : "auto",}}>
        <Row style={{alignItems: "center", 
      justifyContent: "center",}}>
            <Col xs={12} md={8} lg={8} style={{color:"white"}}>
             
              <p style={{fontSize:"0.8rem"}}>
              The choice of the 'OLA' name and logo represents not just an aesthetic preference but a cultural 
              narrative that celebrates heritage and identity. By intertwining a rich cultural background with a 
              minimalist design approach, the brand communicates a deep connection to its roots while appealing to 
              a modern, global audience.
                </p><br/>
                <p style={{fontSize:"0.8rem"}}>
                More than a visual identity, 'OLA' stands as a testament to the power of cultural pride and intentional design 
                to convey a story that resonates universally. Each element, from the name to the monochromatic palette, invites 
                the audience to look beyond the surface and connect with the essence of the brand’s vision for beauty, 
                authenticity, and sophistication.
                </p>
                <p>
                </p>
            </Col>
            <Col xs={12} md={4} lg={4}>
            <Image
              src='/assets/sketch.png'
              alt='sketch-image'
              style={{
                maxWidth: "100%",
                height: "auto",
                borderRadius: "8px",
              }}
            />
            </Col>
        </Row>

  </Container>
  )
}

export default Introtwo;
